import { Box } from "@chakra-ui/react";
import { useDisclosure, useIsMobile } from "@equidefi/hooks";
import { useEffect } from "react";
import { useLocation } from "react-router";
import { useRequireUser } from "../../hooks/useRequireUser";
import { NavDesktopView } from "./DesktopView";
import { NavMobileView } from "./MobileView";

const NavBar = (props) => {
  const { offering, children } = props;
  const logout = useRequireUser({
    onMount: false,
    destination: offering ? `/offerings/${offering.slug}/registration` : "/",
  });
  const isMobile = useIsMobile();
  const menu = useDisclosure();

  const location = useLocation();

  useEffect(() => {
    menu.onClose();
  }, [location.pathname, menu.onClose]);

  return (
    <>
      {isMobile ? (
        <NavMobileView {...props} logout={logout} menu={menu} />
      ) : (
        <NavDesktopView {...props} logout={logout} menu={menu} />
      )}
      <Box ml={{ base: 0, lg: "400px" }} w="full" pb={{ base: 24, lg: 0 }}>
        {children}
      </Box>
    </>
  );
};

export default NavBar;
